<template>
  <div class="container articles-management theme-techno-container theme-bluesky-container mt-100 mb-5">
    <div class="mt-2 popular-articles category-cards"
      v-if="!isContentLoading && !isSearching && searchQuery == '' && Object.keys(allCategoriesAndArticles)?.length > 0">
      <h2 class="card-title pb-3 header-txt-col">Popular Articles</h2>
      <div class="card">
        <div class="card-footer text-muted d-flex justify-content-between pb-0">
          <div class="container p-0">
            <div class="row">
              <div class="col-md-6 mb-3 p-0" v-for="article in popularArticles">
                <ul class="list-group list-group-flush">
                  <li class="list-group-item d-flex justify-content-between align-items-center p-3 pt-2 pb-2">
                    <router-link v-if="isTranslationLoaded(article.article_title)" :to="routeTo(article.id)"
                      class="p-0 popular-articles-home">
                      {{ isTranslationLoaded(article.article_title) }}
                    </router-link>
                    <Skeleton v-else height="2rem" class="mb-1" borderRadius="10px"></Skeleton>
                    <i class="far fa-angle-right"></i>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="popular-articles"
      v-if="!isContentLoading && !isSearching && searchQuery == '' && Object.keys(allCategoriesAndArticles)?.length > 0">
      <div class="card-body p-0 pt-4">
        <h2 class="card-title">Getting Started</h2>
      </div>
    </div>

    <div class="category-cards pt-2"
      v-if="!isContentLoading && !isSearching && searchQuery == '' && Object.keys(allCategoriesAndArticles)?.length > 0">
      <div class="row">
        <div class="col-md-3 pt-3 pb-2" v-for="(category, categoryName) in paginate()">
          <div class="card d-flex flex-column text-center gtamerica">
            <router-link class="card-link" :to="routeToCategoryDetails(allCategoriesAndArticles[categoryName].id)">
              <div class="card-body">
                <div class="cat-icon pb-2">
                  <i :class="category.icon ? `fa ${category.icon}` : 'fa-duotone_t fa-solid fa-folder-open'"
                    class="display-6"></i>
                </div>
                <h3 v-if="isTranslationLoaded(categoryName)" class="card-title mb-0 py-3">
                  {{ isTranslationLoaded(categoryName) }}
                </h3>
                <Skeleton v-else height="2rem" class="mb-1" borderRadius="10px"></Skeleton>
                <template v-if=" category?.description.trim()">
                  <p class="card-text-t text-sm" v-if="isTranslationLoaded(category.description)">
                    {{ isTranslationLoaded(category.description) }}
                  </p>
                  <Skeleton v-else height="1rem" class="mb-1" borderRadius="10px"></Skeleton>
                </template>
              </div>
            </router-link>
            <router-link class="p-0" :to="routeToCategoryDetails(allCategoriesAndArticles[categoryName].id)">
              <div class="card-footer mb-0 text-sm pt-0 text-primary">{{ category?.articles.length }} articles</div>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="mx-auto col-sm-12 pt-4"
      v-if="!isContentLoading && !isSearching && searchQuery == '' && Object.keys(allCategoriesAndArticles)?.length > 0">
      <div class="articles-category p-0 border-0">

        <div class="d-flex" v-if="Object.keys(allCategoriesAndArticles)?.length > pageLimit">
          <div class="d-flex align-items-center justify-content-center text-sm">
            <div class="prevlink me-2">
              <a href="javascript:void(0);"
                :class="pageNumber === 1 ? 'btn btn-xs btn-white mb-0 disabled' : 'btn btn-xs btn-white mb-0'"
                @click="prevPage"><i class="fa fa-chevron-left"></i></a>
            </div>
            <div class="nextlink">
              <a href="javascript:void(0);"
                :class="pageNumber === Math.ceil(Object.keys(allCategoriesAndArticles)?.length / pageLimit) || isNaN(Math.ceil(Object.keys(allCategoriesAndArticles)?.length / pageLimit)) ? 'btn btn-xs btn-white mb-0 disabled' : 'btn btn-xs btn-white mb-0'"
                @click="nextPage"><i class="fa fa-chevron-right"></i></a>
            </div>
            <div class="d-flex align-items-center justify-content-center text-sm"
              v-if="Object.keys(allCategoriesAndArticles)?.length > 0" style="margin-left: 10px">
              Page {{ pageNumber }} of {{ Math.ceil(Object.keys(allCategoriesAndArticles)?.length / pageLimit) }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="techno-searchresults mt--5">
      <div class="row" v-if="searchQuery">
        <div class="col-md-12 mb-0 pt-0">
          <h4 class="card-title mb-0">
            Here's what we found for <strong>{{ searchQuery }}</strong>
          </h4>
        </div>
      </div>

      <div class="popular-articles">
        <div class="srf mt-4 pt-1" :class="searchQuery !== '' ? 'card card-bluesky' : ''">
          <div v-if="isContentLoading || isSearching" class="my-5">
            <div v-if="hubLoader !== ''" class="text-center">
              <img :src="hubLoader" style="max-width: 100%" />
            </div>
            <div v-else>
              <DefaultLoading />
            </div>
          </div>

          <div class="row" v-if="!isContentLoading && !isSearching && searchQuery !== ''">
            <SearchResultWrapper
              :isCustomSubDomain="isCustomSubDomain"
              :library_key="library_key"
              :successArticleSearchId="successArticleSearchId"
              :searchResults="searchResults"
              :isTranslationsLoading="isTranslationsLoading"
              :isTranslationLoaded="isTranslationLoaded"
              :getSearchSubstr="getSearchSubstr"
              :startIdx="startIdx"
              :endIdx="endIdx"
              :pageNumber="pageNumber"
              :pageLimit="pageLimit"
              :prevPageSearch="prevPageSearch"
              :nextPageSearch="nextPageSearch"
              :routeTo="routeTo"
              :routeToCategoryDetails="routeToCategoryDetails"/>
          </div>
        </div>

        <div class="py-4"
          v-if="!isContentLoading && !isSearching && searchQuery == '' && Object.keys(allCategoriesAndArticles)?.length == 0">
          <h3>No articles found</h3>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { useRoute, useRouter } from 'vue-router';
import fgetUserAndHlptCategoriesAndArticles from '@/composables/front/fgetUserAndHlptCategoriesAndArticles';
import NavbarFront from '@/components/custom/front/NavbarFront.vue';
import AppFooter from '@/components/custom/Footer.vue';
import Loading from '@/components/custom/Loading.vue';
import DefaultLoading from '@/components/custom/DefaultLoading.vue';
import getTranslations from '@/composables/getTranslations';
import { projectFirestore } from '@/firebase/config';
import { useStore } from 'vuex';
import { ref } from 'vue';
import getUserCategoryPositioning from '@/composables/getUserCategoryPositioning';
import HeaderShort from '@/components/custom/front/HeaderShort.vue';
import { getSortedSearchResults } from '@/composables/front/searchUtils';
import Api from '@/api/Api';
import SearchResultWrapper from './SearchResultWrapper.vue';
// import HeaderTechno from '@/components/custom/front/HeaderTechno.vue';
import moment from 'moment';
import _ from 'lodash';
export default {
  name: 'BlueSkyHome',
  components: {
    NavbarFront,
    AppFooter,
    Loading,
    DefaultLoading,
    HeaderShort,
    SearchResultWrapper
    // HeaderTechno,
  },
  props: ['searchQuery', 'theme', 'articleTipText', 'articleTipHeading', 'articleTipsstatus'],
  setup(props) {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();

    const session_id = route.params.session_id;
    const isContentLoading = ref(true);
    const articles = ref([]);
    const pageNumber = ref(1);
    const pageLimit = ref(24);
    const startIdx = ref(0);
    const endIdx = ref(24);

    const isCustomSubDomain = ref(false);
    const library_key = ref('');
    const siteIcon = ref('');
    const hubLoader = ref('');
    
    const popularArticles = ref([]);

    const { allCategoriesAndArticles, load_articles_and_categories, searchArticles, isArticlesLoaded, prevSearchQuery } = fgetUserAndHlptCategoriesAndArticles();

    const { getCategoryPositioning, categoryPositioning, updateError } = getUserCategoryPositioning()
    const { fetchTranslation, translations, isTranslationsLoading } = getTranslations();

    const initData = async (lib_id) => {
      await getCategoryPositioning(lib_id);
      await projectFirestore
        .collection('SupportLibraries')
        .doc(lib_id)
        .get()
        .then(doc => {
          if (doc.exists) {
            if (doc.data().publicHelpCenterTheme && doc.data().publicHelpCenterTheme.hubLoader) {
              hubLoader.value = doc.data().publicHelpCenterTheme.hubLoader;
            }

          } else {
            router.push({ name: 'Login' });
          }
        });
      await load_articles_and_categories(lib_id, props.searchQuery, 6);
      let parent_lib_id = store.state.parent_lib_id;
      await fetchPopularArticles(lib_id, parent_lib_id);
      await fetchTranslation(lib_id);
      // console.log('this.allCategoriesAndArticles', allCategoriesAndArticles)
    };

    if (route.params.library_key) {
      library_key.value = route.params.library_key;
      isCustomSubDomain.value = false;
      initData(route.params.library_key);
    } else {
      projectFirestore
        .collection('SupportLibraries')
        .where('custom_subDomain', '==', new URL(window.location.href).hostname)
        .get().then(async snap => {
          if (!snap.empty) {
            library_key.value = snap.docs[0].id;
            initData(snap.docs[0].id);
            isCustomSubDomain.value = true;
          } else {
            router.push({ name: 'Login' });
          }
        });
    }

    const fetchPopularArticles = async (lib_id, parent_lib_id) => {
      let disabled_default_articles = [];
      let disabled_default_categories = [];
      await projectFirestore
        .collection('SupportLibraries')
        .doc(lib_id)
        .get()
        .then(res => {
          if (res.exists) {
            disabled_default_articles = res.data()?.disabled_default_articles ? res.data().disabled_default_articles : [];
            disabled_default_categories = res.data()?.disabled_default_categories ? res.data().disabled_default_categories : [];
          }
        });
      await projectFirestore
        .collection('Articles')
        .where('support_lib_id', 'in', [lib_id, parent_lib_id])
        .where('is_published', '==', true)
        .orderBy('views', 'desc')
        .limit(20)
        .get().then(snap => {
          // console.log('snap',snap)
          if (!snap.empty) {
            snap.docs.forEach(el => {
              if (!disabled_default_articles.includes(el.id) && !disabled_default_categories.includes(el.data().article_categories)) popularArticles.value.push({ ...el.data(), id: el.id });
            });
            popularArticles.value = popularArticles.value.slice(0, 6);
          }
        });
    };

    return {
      allCategoriesAndArticles,
      load_articles_and_categories,
      isArticlesLoaded,
      prevSearchQuery,
      articles,
      store,
      pageLimit,
      pageNumber,
      isContentLoading,
      startIdx,
      endIdx,
      siteIcon,
      hubLoader,
      library_key,
      isCustomSubDomain,
      translations,
      popularArticles,
      searchArticles,
      isTranslationsLoading
    };
  },
  data() {
    return {
      isRTL: false,
      isSearch: false,
      searchResults: [],
      successArticleSearchId: '',
      isSearching: false,
    };
  },
  computed: {
    sortedSearchResults() {
      return getSortedSearchResults(this.searchResults, this.searchQuery);
    },
  },

  methods: {
    nextPage() {
      this.pageNumber += 1;
      this.startIdx += this.pageLimit;
      this.endIdx += this.pageLimit;
      this.paginate();
      this.scrollToTop();
    },
    prevPage() {
      this.pageNumber -= 1;
      this.startIdx -= this.pageLimit;
      this.endIdx -= this.pageLimit;
      this.paginate();
      this.scrollToTop();
    },

    nextPageSearch() {
      this.pageNumber += 1;
      this.startIdx += this.pageLimit;
      this.endIdx += this.pageLimit;
      this.scrollToTop();
    },
    prevPageSearch() {
      this.pageNumber -= 1;
      this.startIdx -= this.pageLimit;
      this.endIdx -= this.pageLimit;
      this.scrollToTop();
    },

    paginate() {
      // console.log('this.allCategoriesAndArticles',this.allCategoriesAndArticles)
      if (this.allCategoriesAndArticles) {
        var result = {};
        for (var index = this.startIdx; index < this.endIdx; index++) {
          var key = Object.keys(this.allCategoriesAndArticles)[index];
          result[key] = this.allCategoriesAndArticles[key];
          if (result[key] == undefined) {
            delete result[key];
          }
        }
        return result;
      }
    },

    scrollToTop() {
      window.scrollTo(0, 0);
    },

    routeTo(resultId) {
      let url = '';
      if (this.isCustomSubDomain) {
        url = '/article/details/' + resultId;
      } else {
        url = '/article/details/' + this.library_key + '/' + resultId;
      }
      return url;
    },
    routeToCategoryDetails(id) {
      let url = '';
      if (this.isCustomSubDomain) {
        url = '/articleCategoriesDetails/' + id;
      } else {
        url = '/articleCategoriesDetails/' + this.library_key + '/' + id;
      }
      return url;
    },

    isTranslationLoaded(dataElement) {
      if (dataElement) {
        let isReplaced = false;

        this.translations.forEach((elem, i) => {
          const searchRegExp = new RegExp(`\\b${elem.source}\\b`, 'gi');
          dataElement = dataElement.replaceAll(searchRegExp, elem.translation);
          if (i == this.translations.length - 1) {
            isReplaced = true;
          }
        });

        return isReplaced ? dataElement : null;
      }
    },

    getSearchSubstr(content) {
      if(!content) return '';
      let splitContent = content.replace(/<[^>]*>?/gm, '').split('. ');
      let filteredContent = splitContent.filter(sentence => sentence.includes(this.searchQuery));
      if (filteredContent.length) {
        return _.truncate(filteredContent[0], {
          length: 370,
          separator: /,?\.* +/,
        });
      } else {
        return _.truncate(splitContent[0], {
          length: 370,
          separator: /,?\.* +/,
        });
      }
    },
    async articlesSearch() {
      this.searchArticles(this.library_key, this.searchQuery).then((res) => {
        const articles  = _.uniqBy(res, 'id');
        setTimeout(() => {
          const data = articles.map(article => ({
            article_category: article.article_categories,
            article_category_title: article?.categoryTitle || '',
            document_id: article.id,
            title: (article.article_title),
            description: (article.article_content),
            keywords: article.article_keywords,
          }));
          this.searchResults = getSortedSearchResults(data, this.searchQuery, true);
          this.addSearchActivity();
          this.isSearching = false;
        }, 1000);
      }).catch((error) => {
       this.$store.dispatch('printLog', {text:'Error in search:', log:error, type:'error'}); 
       this.isSearching = false; 
      });
    },
    async articlesAiSearch() {
      this.searchResults = [];
      this.isSearching = true;
      if(['localhost', 'staging'].some(sub => window.location.hostname.includes(sub))) {
        await Api.searchArticles({
            support_lib_id: this.library_key,
            query: encodeURIComponent(this.searchQuery),
            page:'1',
            page_size:100,
            domain:this.$store.state.library_domain,
            ref_key:this.$store.state.library_refkey
        }).then((res) => {
          if(typeof res?.data === 'object' && res?.data?.length > 0) {
            this.searchResults = res.data;
          } else {
            this.searchResults = [];
          }
          this.addSearchActivity();
          this.isSearching = false;
        }).catch(async (error) => {
          this.$store.dispatch('printLog', {text:'Error in Ai search:', log:error, type:'error'});
          if(error.response?.status && [403, 429, 500, 502, 503, 504].includes(error.response?.status)) {
            await this.articlesSearch();
          } else {
            this.isSearching = false;
          }
        });
      } else {
        await this.articlesSearch();
      }
    },
    addSearchActivity() {
      let payload  = {
        supportLibId : this.library_key,
        firestoreObj : {
            articlesReadId: [],
            articlesReadTitle: [],
            timestamp: moment.utc().valueOf(),
            reviewed:true,
            searchQuery: this.searchQuery,
            status: this.searchResults.length > 0 ? 'passed' : 'failed',
            ticket: 0,
        }
      }
      this.successArticleSearchId = ''
      Api.addSearchActivity(payload).then((res) => {
        if(res?.data?.searchId) {
          this.successArticleSearchId = res.data?.searchId
        }
        this.$store.dispatch('printLog', {text:'Success in addSearchActivity:', log:res, type:'success'});
      }).catch((error) => {
        this.$store.dispatch('printLog', {text:'Error in addSearchActivity:', log:error, type:'error'});
      })
    },
  },
  async mounted() {
    this.$store.state.showSidenav = false;
    this.$store.state.showNavbar = false;
    this.$store.state.showFooter = false;
    if (this.$route.query?.search && this.$route.query?.search?.trim() !== '' && this.library_key) {
      this.isSearch = true;
      this.articlesAiSearch();
    }
  },
  beforeUnmount() {
    this.$store.state.showSidenav = true;
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    if (this.$store.state.isPinned === false) {
      const sidenav_show = document.querySelector('.g-sidenav-show');
      sidenav_show.classList.remove('g-sidenav-hidden');
      sidenav_show.classList.add('g-sidenav-pinned');
      this.$store.state.isPinned = true;
    }
  },
  watch: {
    'library_key': {
      handler() {
        if (this.$route.query?.search && this.$route.query?.search?.trim() !== '') {
          this.isSearch = true;
          this.articlesAiSearch();
        }
      },
    },
    async searchQuery() {
      this.pageNumber = 1;
      this.pageLimit = 20;
      this.startIdx = 0;
      this.endIdx = 20;
      if (this.searchQuery !== '') {
        this.isSearch = true;
        this.articlesAiSearch();
      } else {
        this.isSearch = false;
      }
    },
    translations() {
      if (this.translations.length) {
        this.isContentLoading = false;
      }
    },
    allCategoriesAndArticles: {
      deep: true,
      handler() {
        if (!this.isSearch) {
          this.isContentLoading = false;
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
$font-color: #00ff00 !default;

body.blueskype-bg .hub-theme-bluesky {
  background:
        linear-gradient(-200deg, #ffffff, transparent 15%),
        linear-gradient(20deg, var(--spectrumColorC), transparent 10%),
        linear-gradient(140deg, var(--spectrumColorTL), transparent 20%), 
        linear-gradient(330deg, var(--spectrumColorC), transparent 20%),
        linear-gradient(240deg, var(--spectrumColorTR), var(--spectrumColorC) 20%); 
}

body.blueskype-bg .hub-theme-bluesky.hub-theme-bluesky-light {
  background: 
        linear-gradient(-200deg, #ffffff, transparent 15%),
        linear-gradient(20deg, var(--spectrumColorC), transparent 10%),
        linear-gradient(140deg, var(--spectrumColorC), transparent 20%), 
        linear-gradient(330deg, var(--spectrumColorC), transparent 20%),
        linear-gradient(240deg, var(--spectrumColorR-hover), var(--spectrumColorC) 20%) !important;  
        min-height: 350px;
}
// body.blueskype-bg .hub-theme-bluesky.hub-theme-bluesky-light.noAfterBeforeShapes {
//   background:
//     linear-gradient(150deg, #ecedee, transparent 30%),
//     linear-gradient(330deg, rgb(210, 206, 242), transparent 30%),
//     linear-gradient(225deg, #fff0be, #fbdce7, #e2fae1, powderblue) !important;
// }
</style>
